import type { ImageAssetUploader } from "@staylayer/puck-components";
import { uploadImageAsset } from "../api/pages";

function formatBytes(bytes: number) {
  if (bytes < 1024) {
    return `${bytes} B`;
  }

  if (bytes < 1024 * 1024) {
    return `${(bytes / 1024).toFixed(bytes < 10 * 1024 ? 1 : 0)} KB`;
  }

  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

function resolveAbsoluteAssetUrl(relativeUrl: string): string {
  if (typeof window === "undefined") {
    return relativeUrl;
  }

  try {
    return new URL(relativeUrl, window.location.origin).toString();
  } catch {
    return relativeUrl;
  }
}

export function createDashboardImageAssetUploader(options?: {
  absoluteUrl?: boolean;
}): ImageAssetUploader {
  return async ({ file, preset }) => {
    const asset = await uploadImageAsset(file, preset);
    const value = options?.absoluteUrl
      ? resolveAbsoluteAssetUrl(asset.relativeUrl)
      : asset.relativeUrl;
    const requiresHttpsWarning =
      options?.absoluteUrl && !value.startsWith("https://");

    return {
      value,
      message: requiresHttpsWarning
        ? `Uploaded ${formatBytes(asset.byteSize)}. This URL is absolute, but email logo saves still require an HTTPS public origin.`
        : `Uploaded ${formatBytes(asset.byteSize)} as a hosted asset.`,
    };
  };
}

export const dashboardImageAssetUploader = createDashboardImageAssetUploader();
export const dashboardAbsoluteImageAssetUploader =
  createDashboardImageAssetUploader({ absoluteUrl: true });
